module.exports = __webpack_public_path__ + "53983f1f7bf16b4ea597bda02554dce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/3.jpg
// module id = 1357
// module chunks = 47